import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { Plus, Minus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/5 last:border-0" data-id="element-70">
      <button className="w-full py-8 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-71">
        <span className={`text-lg md:text-xl font-bold transition-colors duration-300 pr-8 font-sans ${isOpen ? 'text-premium-gold-luminous' : 'text-white'}`} data-id="element-72">
          {question}
        </span>
        <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-premium-gold text-navy-950 rotate-180' : 'bg-white/5 text-premium-gold'}`} data-id="element-73">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-74" /> : <Plus className="w-4 h-4" data-id="element-75" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] pb-8 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-76">
        <p className="text-gray-300 leading-relaxed text-base md:text-lg font-sans opacity-90 border-l-2 border-premium-gold/30 pl-6" data-id="element-77">
          {answer}
        </p>
      </div>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Funciona para niños muy intensos o con alta sensibilidad?',
    a: 'Sí. El sistema está diseñado específicamente para niños con alta intensidad emocional. El Tomo 1 explica la neurología de los niños de alta reactividad y el Tomo 2 tiene un protocolo específico para el Anclaje Físico en niños de alta sensibilidad.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Inmediatamente después del pago recibís un email con el acceso a todos los archivos. En menos de 5 minutos tenés todo disponible para leer, imprimir o guardar en el celular.'
  }, {
    q: '¿Qué lo diferencia de lo que encuentro gratis en Instagram?',
    a: 'El contenido gratuito da conceptos. El MegaPack da protocolos. La diferencia es la misma que entre saber que el mate quema y tener el protocolo para curar la quemadura. Aquí tenés los pasos exactos, las frases exactas y las herramientas listas para usar en el momento de la crisis.'
  }, {
    q: '¿Sirve si mi pareja no está de acuerdo con la crianza respetuosa?',
    a: 'Sí. El sistema no es ideológico. Es práctico. Funciona desde distintos estilos de crianza porque se basa en neurología y psicología del desarrollo, no en una corriente específica. El Tomo 4 de Límites con Amor está especialmente diseñado para padres que valoran tanto la conexión como la autoridad.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin condiciones. Si lo abrís, lo usás y no te convence, escribís a mundopractico.oficial@gmail.com y te devolvemos el 100% sin preguntas.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-78">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-79">
        <FadeIn data-id="element-80">
          <div className="flex flex-col items-center mb-16" data-id="element-81">
            <div className="bg-white/5 text-gray-400 px-6 py-2 rounded-full border border-white/10 text-xs font-bold tracking-[0.2em] mb-6 uppercase" data-id="element-82">
              DESPEJÁ TUS DUDAS
            </div>
            <h2 className="text-3xl md:text-5xl text-center text-white leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-83">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h2>
          </div>
          <div className="bg-navy-950 rounded-3xl border border-white/10 p-8 md:p-12" data-id="element-84">
            {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} data-id="element-85" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};